import { Translator } from 'Translator';
import { SubOption } from 'model/Filters';

const durationSubOptions = [
  {
    id: 31,
    name: Translator.translate(
      'UserEnvironment.Filters.lessThanThreeHours',
      { hours: 3 },
      true,
      'Less than {hours} hours',
    ),
    value: 'less-than-3-hours',
  },
  {
    id: 32,
    name: Translator.translate(
      'UserEnvironment.Filters.halfDay',
      {},
      true,
      'Half day',
    ),
    value: 'half-day',
  },
  {
    id: 33,
    name: Translator.translate(
      'UserEnvironment.Filters.fullDay',
      {},
      true,
      'Full day',
    ),
    value: 'full-day',
  },
] as SubOption[];

export default durationSubOptions;
